import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/api.service';

export const authGuard = () => {
  const router = inject(Router);
  
  if (AuthService.isAuthenticated()) {
    return true;
  } else {
    router.navigate(['/auth']);
    return false;
  }
}; 